/**
 * First-wins merge of error maps. Returns undefined when the result is empty.
 *
 * OrgScopedCrudService merges as `mergeErrors(l1, l0)` so L1 wins on the same
 * field (request 0320). Callers that still compose L0+L1 locally should pass
 * L1 first when L1 must win.
 */
export function mergeErrors(...maps) {
    const out = {};
    for (const m of maps) {
        if (m) {
            for (const [k, v] of Object.entries(m)) {
                if (!(k in out))
                    out[k] = v;
            }
        }
    }
    return Object.keys(out).length > 0 ? out : undefined;
}
//# sourceMappingURL=mergeErrors.js.map